/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentDraftsControllerHistoryQueryResponse, DocumentDraftsControllerHistoryPathParams, DocumentDraftsControllerHistoryQueryParams, DocumentDraftsControllerHistory400, DocumentDraftsControllerHistory401, DocumentDraftsControllerHistory403, DocumentDraftsControllerHistory404 } from "../../models/documentDraftsController/DocumentDraftsControllerHistory";

function getDocumentDraftsControllerHistoryUrl(threadId: DocumentDraftsControllerHistoryPathParams["threadId"]) {
  const res = { method: 'GET', url: `/api/v1/document-drafts/${threadId}` as const }  
  return res
}

/**
 * {@link /api/v1/document-drafts/:threadId}
 */
export async function documentDraftsControllerHistory(threadId: DocumentDraftsControllerHistoryPathParams["threadId"], params: DocumentDraftsControllerHistoryQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentDraftsControllerHistoryQueryResponse, ResponseErrorConfig<DocumentDraftsControllerHistory400 | DocumentDraftsControllerHistory401 | DocumentDraftsControllerHistory403 | DocumentDraftsControllerHistory404>, unknown>({ method : "GET", url : getDocumentDraftsControllerHistoryUrl(threadId).url.toString(), params, ... requestConfig })  
  return res.data
}